<template>
    <MoveLocation></MoveLocation>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const MoveLocation = defineAsyncComponent(() =>
    import("../../components/Logistics/MoveLocation.vue")
);
export default {
    name: "Logistics_MoveLocation", //The name you are in should not equal the name of the component you are importing.
    components: { MoveLocation, AuthLayout },
};
</script>